import { CAR_VIEWS } from '../car-view.js';
import { CHECKLIST_LIMITS } from '../checklist/limits.js';
import { POINT_TYPES_V2 } from '../checklist/pointKinds.js';
import { DEFECT_ZONES } from '../defect-zone.js';
/**
 * Photo angles of a stage act. Append-only; stored and read as plain `string`
 * (an old client may meet a newer key).
 */
export const STAGE_ACT_ANGLES = ['front', 'rear', 'left', 'right', 'interior', 'odometer'];
/**
 * AUT-869 — photo angles of a moto act: no interior, the VIN on the frame
 * («VIN на раме»). A list of its own, so the car list never grows. Append-only.
 */
export const MOTO_STAGE_ACT_ANGLES = [
    'front',
    'rear',
    'left',
    'right',
    'odometer',
    'vin_frame',
];
export function stageActAnglesFor(kind) {
    return kind === 'moto' ? MOTO_STAGE_ACT_ANGLES : STAGE_ACT_ANGLES;
}
export const STAGE_ACT_LIMITS = {
    maxPoints: 40,
    maxCommentLength: CHECKLIST_LIMITS.maxNoteLength,
};
/** Point mode of a stage act: every zone, all five views, the v2 point types. */
export const STAGE_ACT_POINT_SPEC = {
    side: 'front',
    zones: DEFECT_ZONES,
    points: true,
    pointViews: CAR_VIEWS,
    pointTypesByZoneKind: POINT_TYPES_V2,
};
//# sourceMappingURL=stage-act.js.map